import URLImage from './URLImage.js';

import React from 'react';

class Bench extends React.Component {
    render() {
        return <URLImage x={this.props.x} y={this.props.y} scaleX={3} scaleY={3} src={this.props.benchImage} preventDefault={false} onload={this.props.onload}></URLImage>;
    }
}
export default Bench;